export const activities = [
  {
    id: 1,
    title: 'Elektrik Ürün Tedariği',
    description: 'Geniş ürün gruplarında güvenilir ve sürdürülebilir tedarik çözümleri sunuyoruz.',
    icon: 'ri-shopping-bag-3-line',
    detail: 'Elektrik ve elektronik sektörüne yönelik geniş ürün gruplarında tedarik, satış hizmetleri sunuyoruz. Bayiliğini ve temsilciliğini yürüttüğümüz markalara ait ürünlerin tanıtımını, teminini ve satışını gerçekleştirerek müşterilerimize güvenilir ve sürdürülebilir tedarik çözümleri sağlıyoruz.',
  },
  {
    id: 2,
    title: 'Kurumsal Tedarik ve İhale',
    description: 'Kurumsal firmaların satın alma ve ihale süreçlerinde tedarikçi olarak yer alıyoruz.',
    icon: 'ri-file-list-3-line',
    detail: 'Kurumsal firmaların satın alma ve ihale süreçlerinde tedarikçi olarak yer alıyor; ihtiyaç duyulan elektrik ve elektronik ürünlerin doğru, hızlı ve rekabetçi koşullarla temin edilmesine destek oluyoruz.',
  },
  {
    id: 3,
    title: 'Pano İmalatı',
    description: 'Montajlı ve montajsız elektrik panolarının imalatını profesyonel ekibimizle gerçekleştiriyoruz.',
    icon: 'ri-tools-line',
    detail: 'Montajlı ve montajsız elektrik panolarının imalatı, elektrik projelerinde kullanılan pano sistemlerinin hazırlanması faaliyet alanlarımız arasında yer almaktadır.',
  },
  {
    id: 4,
    title: 'Elektrik Taahhüt',
    description: 'Proje gereksinimlerine uygun teknik çözümler sunarak uygulama süreçlerinde hizmet veriyoruz.',
    icon: 'ri-building-4-line',
    detail: 'Elektrik taahhüt işleri kapsamında proje gereksinimlerine uygun teknik çözümler sunarak uygulama süreçlerinde güvenilir çözüm ortağı olarak hizmet veriyoruz.',
  },
  {
    id: 5,
    title: 'Teknik Destek ve Danışmanlık',
    description: 'Satış öncesi yönlendirme, ürün tedariği ve proje bazlı çözümler sunuyoruz.',
    icon: 'ri-customer-service-2-line',
    detail: 'Satış öncesi yönlendirme, ürün tedariği, teknik destek ve proje bazlı çözümleriyle müşterilerimize bütüncül bir hizmet anlayışı sunmayı amaçlamaktayız.',
  },
];

export const applications = [
  {
    id: 1,
    title: 'Ana Kuvvet Dağıtım Panoları',
    description: 'Proje gereksinimlerine uygun ana kuvvet dağıtım panolarının tasarımını, üretimini ve montajını gerçekleştiriyoruz.',
    category: 'Dağıtım',
    imageSeq: 'app-power-distribution',
  },
  {
    id: 2,
    title: 'Kumanda Panoları',
    description: 'Makine ve proses kontrol ihtiyaçlarına yönelik kumanda panolarının projelendirme, üretim ve uygulama süreçlerini yürütüyoruz.',
    category: 'Kontrol',
    imageSeq: 'app-control-panels',
  },
  {
    id: 3,
    title: 'Otomasyon ve PLC Panoları',
    description: 'Endüstriyel otomasyon projeleri için PLC tabanlı pano çözümleri sunuyoruz.',
    category: 'Otomasyon',
    imageSeq: 'app-plc-automation',
  },
  {
    id: 4,
    title: 'Kompanzasyon Panoları',
    description: 'İşletmelerin enerji verimliliği hedeflerine yönelik kompanzasyon panolarının üretim ve uygulama hizmetlerini sunuyoruz.',
    category: 'Enerji',
    imageSeq: 'app-compensation',
  },
  {
    id: 5,
    title: 'Elektrik Taahhüt Uygulamaları',
    description: 'Keşif, projelendirme, uygulama ve devreye alma süreçlerini uzman ekibimizle yönetiyoruz.',
    category: 'Taahhüt',
    imageSeq: 'app-electrical-contracting',
  },
  {
    id: 6,
    title: 'Pnömatik Uygulamaları',
    description: 'Endüstriyel tesislerin ihtiyaçlarına yönelik pnömatik sistemlerin kurulumu ve entegrasyonunu gerçekleştiriyoruz.',
    category: 'Pnömatik',
    imageSeq: 'app-pneumatic',
  },
];

export const references = [
  { id: 1, company: 'T.C.D.D. Sirkeci Garı', project: 'Kompanze Panoları', category: 'Kurumsal Proje' },
  { id: 2, company: 'D.M.O.', project: 'Çevre Aydınlatması Kuvvet ve Dağıtım Panoları Yapımı', category: 'Kamu Projesi' },
  { id: 3, company: 'Mitsubishi Akyüzler Servisi', project: 'Komple Anahtar Teslim Elektrik Taahhütü', category: 'Kurumsal Proje' },
  { id: 4, company: 'Garanti İplik', project: 'Trafo Merkezleri ve Kuvvet Dağıtım Panoları Yapımı', category: 'Endüstriyel Proje' },
  { id: 5, company: 'Else Tekstil', project: 'Ana Dağıtım Panoları Yapımı', category: 'Endüstriyel Proje' },
  { id: 6, company: 'Alışan Nakliyat Kimyasal Temizlik', project: 'Elektrik Taahhüt İşleri', category: 'Kurumsal Proje' },
  { id: 7, company: 'Chrysler Yapı Kooperatifi Konutları', project: 'Trafo Merkezleri ve Elektrik Taahhüt İşleri', category: 'Konut Projesi' },
  { id: 8, company: 'Dentrium Diş Hastanesi', project: 'Elektrik Taahhüt İşleri', category: 'Sağlık Projesi' },
  { id: 9, company: 'GİSAD Merkez Binası', project: 'Elektrik İşleri', category: 'Kurumsal Proje' },
  { id: 10, company: 'İmaj İç Dış Ticaret A.Ş.', project: 'Elektrik Taahhüt İşleri', category: 'Kurumsal Proje' },
  { id: 11, company: 'Kuyumcu Kent', project: 'Kablo Kanalları, MCC Besleme ve Otomasyon Kabloları Çekimi', category: 'Ticari Proje' },
  { id: 12, company: 'Fresh Tekstil', project: 'Elektrik Pano ve Taahhüt İşleri', category: 'Endüstriyel Proje' },
  { id: 13, company: 'Glaxo & Well', project: 'Otomasyon Panoları Yapımı', category: 'Endüstriyel Proje' },
  { id: 14, company: 'Deva İlaç', project: 'Otomasyon Panoları Yapımı', category: 'Endüstriyel Proje' },
  { id: 15, company: 'M&T Reklam', project: 'Elektrik Taahhüt İşleri', category: 'Kurumsal Proje' },
  { id: 16, company: 'Nurol Tarabya Sitesi', project: 'Havai Hattın Yer Altına Alınması', category: 'Konut Projesi' },
  { id: 17, company: 'KC Grup Bahçeşehir A.V.M.', project: 'Otomasyon İşleri Yapımı', category: 'Ticari Proje' },
  { id: 18, company: 'İstanbul Büyükşehir Belediyesi Trafik Eğitim Merkezi', project: 'Elektrik Taahhütü', category: 'Kamu Projesi' },
  { id: 19, company: 'LC Waikiki Depo İnşaatları', project: 'Elektrik Malzeme ve Taahhüt İşleri', category: 'Kurumsal Proje' },
  { id: 20, company: 'Maris Otel', project: 'Komple Malzeme Temini', category: 'Turizm Projesi' },
  { id: 21, company: 'Magic Life', project: 'Elektrik Malzemeleri Temini', category: 'Turizm Projesi' },
  { id: 22, company: 'Kemalpaşa Doğal Gaz Santrali', project: 'Şantiye Malzemesi Temini', category: 'Enerji Projesi' },
  { id: 23, company: '4. Levent - Maslak Metro Hattı', project: 'Otomasyon Enstrümanları Montajı', category: 'Ulaşım Projesi' },
  { id: 24, company: 'Mustafa Öncel İlköğretim Okulu', project: 'Malzeme Temini', category: 'Eğitim Projesi' },
  { id: 25, company: 'Mustafa Öncel İlköğretim Okulu', project: 'Ana Dağıtım Panoları ve Kat Dağıtım Panolarının Montajı', category: 'Eğitim Projesi' },
];

export const solutionPartners = [
  { id: 1, name: 'Schneider Electric', country: 'Fransa' },
  { id: 2, name: 'Siemens', country: 'Almanya' },
  { id: 3, name: 'ABB', country: 'İsviçre/İsveç' },
  { id: 4, name: 'Legrand', country: 'Fransa' },
  { id: 5, name: 'Mitsubishi Electric', country: 'Japonya' },
  { id: 6, name: 'Phoenix Contact', country: 'Almanya' },
  { id: 7, name: 'Wago', country: 'Almanya' },
  { id: 8, name: 'Weidmüller', country: 'Almanya' },
  { id: 9, name: 'FANUC', country: 'Japonya' },
  { id: 10, name: 'Omron', country: 'Japonya' },
];